import { PagamentoModel } from './PagamentoModel'

export class CupomModel {
  id: number
  parceiroId?: number
  parceiro?: any // ParceiroModel
  valorDesconto: number
  percentualDesconto: number
  codigo: string
  repasses: string
  dataInicioVigencia: string
  dataFimVigencia: string
  pagamentos: PagamentoModel[]
  valorComissao: number
  percentualComissao: number
  ufs: string[]
  cursos: number[]

  usuarioId?: number
  createdAt: Date
  // [texto que indica quanto de desconto por indicação cada matrícula efetuada usando esse cupom irá gerar para o usuário que criou esse cupom]: {
  //   reciclagem: 5,
  //   especializacao: 10,
  //   atualizacao: 5
  // }
}

// const cupom: CupomModel = {
//   parceiroId: null,
//   valorDesconto: null,
//   percentualDesconto: 5,
//   codigo: 'Vitoncio5',
//   repasses: null,
//   dataInicioVigencia: null,
//   dataFimVigencia: null,
//   valorComissao: null,
//   percentualComissao: null,
//   ufs: null,
//   cursos: null,

//   usuarioId: 21938,
//   desconto: {
//     reciclagem: 5,
//     especializacao: 10,
//     atualizacao: 5,
//   },
// }

// interface DescontoIndicacao {
//   createdAt: Date
//   valor: number
//   matriculaId: number // Importante levar em consideração a
//   cupomId: number // considerar o usuário id
//   dataConsumo
// }
